import { captureException, dedupeIntegration, globalHandlersIntegration, init } from '@sentry/react';
import { sanitizeMonitoringEvent } from './errorMonitoringPrivacy';
import { dsn } from './sentryPublicDsn.json';

// This DSN is public and ingest-only: it cannot read errors or administer Sentry.
const enabled = import.meta.env.PROD && ['zavira.ca', 'www.zavira.ca'].includes(window.location.hostname);

try {
init({
  dsn,
  enabled,
  environment: 'production',
  release: `zavira-web@${typeof __ZAVIRA_BUILD_ID__ === 'string' ? __ZAVIRA_BUILD_ID__ : 'local'}`,
  defaultIntegrations: false,
  integrations: [globalHandlersIntegration(), dedupeIntegration()],
  sendDefaultPii: false,
  enableLogs: false,
  sendClientReports: false,
  maxBreadcrumbs: 0,
  beforeSend: event => sanitizeMonitoringEvent(event, window.location.pathname),
});
} catch { /* Monitoring initialization must not block the application. */ }

export function reportApplicationException(error: unknown): string | undefined {
  if (!enabled) return;
  try { return captureException(error); } catch { /* Monitoring must never break bookings. */ }
}
